export default "__VITE_ASSET__DYjjHjcu__"